import { render } from "./B2BLogin.vue?vue&type=template&id=2846b890"
import script from "./B2BLogin.vue?vue&type=script&lang=js"
export * from "./B2BLogin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__